import flagKeys from '@/constants/flagKeys';
import PurchasedCoins from '@/views/Transactions/PurchasedCoins.vue';
import { Route } from '../route.model';

const coinsPurchased = new Route(
  '/transactions/coins/purchased',
  'transaction_coins_purchased',
  PurchasedCoins,
  {
    requiresAuth: true,
    requiresCountry: ['United States'],
    isResponsive: flagKeys.responsiveDashboard,
    flag: flagKeys.legacyReports,
    zendesk: {
      mobile: {
        offsetHorizontal: '4px',
        offsetVertical: '4px'
      }
    },
    navbar: {
      name: 'Coins Purchased', // TODO apply i18n
      icon: 'coins'
    }
  }
);

export { coinsPurchased };
export default coinsPurchased;
